import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

// Inline amber banner shown above features that are blocked while a
// subscription is paused. Reads mem_pause_status from site_settings so
// it appears as soon as the user lands on a gated page.
//
// Two ways to render:
//   <SubscriptionPausedBanner />           // self-gated, only renders if paused
//   <SubscriptionPausedBanner force />     // always renders (e.g. from an
//                                          // API response that returned
//                                          // { paused: true })
const SubscriptionPausedBanner = ({ force = false, message }) => {
  const isPaused = useSelector(
    (state) =>
      Number(state?.fetchSiteSettings?.site_settings?.member?.mem_pause_status) === 1
  );

  if (!force && !isPaused) return null;

  return (
    <div
      role="alert"
      style={{
        background: "#fff8e1",
        border: "1px solid #f5c542",
        color: "#5a4500",
        padding: "12px 16px",
        borderRadius: 4,
        margin: "12px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <span style={{ fontSize: 14 }}>
        {message ||
          "Your subscription is paused. Resume your subscription to use this feature."}
      </span>
      <Link
        to="/account-settings"
        className="site_btn sm_btn"
        onClick={() => {
          // Drop the user on the membership tab when they land on settings.
          try {
            localStorage.setItem(
              "accout-settings-active-tab",
              "MembershipManagement"
            );
          } catch (_) {
            // localStorage may be blocked; failing silently is fine here.
          }
        }}
      >
        Resume Subscription
      </Link>
    </div>
  );
};

export default SubscriptionPausedBanner;
